var _g, _g2, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserResponsible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.3,
    height: 21.45,
    viewBox: "0 0 23.3 21.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-responsible") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user-responsible"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.1,14.4a6.8,6.8,0,1,1,6.8,6.8A6.81,6.81,0,0,1,5.1,14.4Zm1,0a5.8,5.8,0,1,0,5.8-5.8A5.8,5.8,0,0,0,6.1,14.4Z",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,21.5l-1.4-1.4a.49.49,0,1,1,.7-.7l1.4,1.4a.48.48,0,0,1,0,.7.52.52,0,0,1-.4.2C18.7,21.7,18.7,21.6,18.6,21.5Z",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(9.57 16.96) rotate(-0.43)",
    fontSize: 10.42,
    fill: "{props.color}",
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "?"), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_79",
    "data-name": "Capa 79"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.8,6.7h0A2.61,2.61,0,0,1,2.1,4.1,2.65,2.65,0,0,1,4.7,1.5,2.65,2.65,0,0,1,7.3,4.1,2.5,2.5,0,0,1,4.8,6.7ZM2.9,4.1A2,2,0,0,0,4.7,6h.2a1.9,1.9,0,1,0-2-1.9Z",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,11.8A2.24,2.24,0,0,1,.6,10,2.24,2.24,0,0,1,1.7,8.2a5.42,5.42,0,0,1,5.5,0,.35.35,0,0,1,.1.5c-.1.2-.4.3-.5.1a4.9,4.9,0,0,0-4.7,0A1.91,1.91,0,0,0,1.4,10a1.91,1.91,0,0,0,.7,1.2,4.14,4.14,0,0,0,2.3.6.4.4,0,1,1,0,.8A5,5,0,0,1,1.7,11.8Z",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,6.7A2.56,2.56,0,0,1,17,4.1a2.6,2.6,0,1,1,5.2,0,2.58,2.58,0,0,1-2.6,2.6Zm.1-4.5a1.9,1.9,0,0,0-1.9,1.9A2,2,0,0,0,19.5,6h.2a1.82,1.82,0,0,0,1.8-1.9A1.9,1.9,0,0,0,19.6,2.2Z",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4,11.8A2.24,2.24,0,0,0,23.5,10a2.24,2.24,0,0,0-1.1-1.8,5.42,5.42,0,0,0-5.5,0,.36.36,0,0,0,.4.6,4.9,4.9,0,0,1,4.7,0,1.31,1.31,0,0,1,.7,1.2,1.91,1.91,0,0,1-.7,1.2,4.14,4.14,0,0,1-2.3.6.4.4,0,1,0,0,.8A5,5,0,0,0,22.4,11.8Z",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-0.4 -1.3)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-0.4 -1.3)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,15.41",
    transform: "translate(-0.4 -1.3)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserResponsible);
export default __webpack_public_path__ + "static/media/user-responsible.68fc9847f63d08ac4c22212498cfce73.svg";
export { ForwardRef as ReactComponent };